import classNames from 'classnames';
import { object, shape } from 'prop-types';
import React from 'react';
import { Input } from '@eika/input';
// import { CurrencyInput } from '@eika/currency-input';
// import Cleave from 'cleave.js/react';
import { SkjemaSporsmal } from '../../ahv-schema';
import { SPORSMALSTYPE_AMOUNT_CAP } from '../../constants/general';
import connect from '../helper/connect';
import { isNumberEmpty, validerMonster } from '../helper/validation-helper';
import ErrorMessage from '../errormessage';

function notWithinRange(range, value) {
    let min;
    let max;
    if (range) {
        const parsed = JSON.parse(range);
        ({ min, max } = parsed);
    }

    if (value && range) {
        return min > value || max < value;
    }
    return false;
}

/**
 * Calculates how many characters should be the maximum that can be input in a number field based on a range
 *
 * @param range in json string format.
 * @returns {number|undefined} required input field length for given range
 */
export function maxLengthFromRange(range) {
    if (!range) return undefined;
    const parsed = JSON.parse(range);
    if (parsed.min === undefined && parsed.max === undefined) return undefined;
    const maxLengthNumbers = Math.max(parsed?.min?.toString()?.length ?? 0, parsed?.max?.toString()?.length ?? 0);
    const maxLengthGroupingWhitespaces = Math.floor((maxLengthNumbers - 1) / 3);
    return maxLengthNumbers + maxLengthGroupingWhitespaces;
}

function NumberQuestionType({
    question: { definisjon, instruks, sporsmalstekst, range, valideringsMonster, type },
    context,
}) {
    const maxLength = maxLengthFromRange(range);
    const onChange = (e) => {
        context.onChange(definisjon, { value: parseInt(e.target.value, 10), error: false });
    };

    const hasError = () => {
        const currentValue = context.getValue(definisjon);
        return (
            isNumberEmpty(currentValue) ||
            notWithinRange(range, currentValue) ||
            !validerMonster(currentValue, valideringsMonster)
        );
    };

    const hasInvalidValue = context.hasError(definisjon);

    return (
        <div className={classNames({ 'has-error error': hasInvalidValue })}>
            <h2 className="skjema-input-question">{sporsmalstekst}</h2>
            {type === SPORSMALSTYPE_AMOUNT_CAP ? (
                <Input
                    // TODO: Use new CurrencyInput-component if supposed to...
                    // <Cleave
                    // <CurrencyInput
                    onChange={onChange}
                    // onChange={onChangeAmount}
                    name={definisjon}
                    className={classNames('form-control', { invalid: hasInvalidValue })}
                    options={{ numeral: true, numeralDecimalMark: ',', delimiter: ' ', rawValueTrimPrefix: true }}
                    id={definisjon}
                    value={context.getValue(definisjon)}
                    onBlur={() => context.updateValidation(definisjon, true, hasError())}
                    aria-label={sporsmalstekst}
                    type="number"
                    maxLength={maxLength}
                    inputMode="decimal"
                />
            ) : (
                <Input
                    onChange={onChange}
                    name={definisjon}
                    className="form-control"
                    id={definisjon}
                    onBlur={() => context.updateValidation(definisjon, true, hasError())}
                    value={context.getValue(definisjon)}
                    type="number"
                    maxLength={maxLength}
                    inputMode="decimal"
                />
            )}
            <ErrorMessage text={hasInvalidValue ? instruks : ''} />
        </div>
    );
}

NumberQuestionType.propTypes = {
    question: shape(SkjemaSporsmal).isRequired,
    context: object,
};

export default connect(React.memo(NumberQuestionType));
